/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { HTTPValidationError, RequestReviewRequest } from './platformapi.schemas';

import requestReviewMutator from '../custom-axios-instance';

/**
 * Endpoint to request review of a project.
 * @summary Request Review
 */
export const requestReview = (requestReviewRequest: RequestReviewRequest, signal?: AbortSignal) => {
  return requestReviewMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/projects/request-review`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: requestReviewRequest,
    signal,
  });
};

export const getRequestReviewMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestReview>>,
    TError,
    { data: RequestReviewRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestReview>>,
  TError,
  { data: RequestReviewRequest },
  TContext
> => {
  const mutationKey = ['requestReview'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestReview>>,
    { data: RequestReviewRequest }
  > = (props) => {
    const { data } = props ?? {};

    return requestReview(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestReviewMutationResult = NonNullable<Awaited<ReturnType<typeof requestReview>>>;
export type RequestReviewMutationBody = RequestReviewRequest;
export type RequestReviewMutationError = void | HTTPValidationError;

/**
 * @summary Request Review
 */
export const useRequestReview = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestReview>>,
      TError,
      { data: RequestReviewRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestReview>>,
  TError,
  { data: RequestReviewRequest },
  TContext
> => {
  const mutationOptions = getRequestReviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
